import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { createStyles, makeStyles, TextField, Theme } from '@material-ui/core';
import { validationMessage } from '../../../const/ProcessConst';

type TProps = {
  name: any;
  label?: string;
  defaultValue?: string;
  errorMessage?: string | undefined;
  style?: React.CSSProperties;
  required?: boolean;
  fullWidth?: boolean;
  onChange?: any;
  fromDate?: string;
  toDate?: string;
  className?: string;
  errorMessageStyle?: React.CSSProperties;
};

export const SiteProcessDatetimePicker: React.VFC<TProps> = React.memo(
  (props: TProps) => {
    const classes = useStyles();

    // react-hook-fomrを使用する前提のcomponent
    const { register, control } = useFormContext();
    const height = 34;

    // https://mui.com/components/text-fields/#main-content の必要なpropsを追加する
    const {
      name,
      label,
      defaultValue,
      errorMessage,
      style,
      required = false,
      fullWidth = false,
      onChange,
      fromDate,
      toDate,
      className,
      errorMessageStyle
    } = props;

    return (
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <TextField
            {...register(name, {
              required: {
                value: required, // required=trueのpropsがある場合にバリデーション有効
                message: validationMessage.required
              },
              min: fromDate && {
                // fromDateがpropsにある場合にバリデーション有効
                value: fromDate,
                message: validationMessage.dateFrom
              },
              max: toDate && {
                // toDateがpropsにある場合にバリデーション有効
                value: toDate,
                message: validationMessage.dateFromTo
              }
            })}
            type='datetime-local'
            fullWidth={fullWidth}
            defaultValue={defaultValue}
            className={`${classes.textField} ${className}`}
            error={errorMessage !== undefined} // errorMessageがあればエラーのスタイルを適用
            helperText={errorMessage}
            variant='outlined'
            placeholder={label}
            style={style}
            inputProps={{
              style: {
                height,
                padding: '0 14px'
              },
              className: classes.dateteimeInput
            }}
            onChange={onChange}
            FormHelperTextProps={{
              style: errorMessageStyle
            }}
          />
        )}
      />
    );
  }
);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    textField: {
      backgroundColor: 'white'
    },
    dateteimeInput: {
      minWidth: 180
    }
  })
);
